/**
 * Registry of third-party (external system) export providers.
 *
 * Each provider is a descriptor (see ./osapiens.js) that knows how to validate the DD data,
 * build its system-specific file, serialize it and name it. The Final Report's export flow is
 * fully driven by this registry: adding a new system = add a descriptor and register it here.
 */
import osapiens from './osapiens.js';

const PROVIDERS = [osapiens];

export const THIRD_PARTY_PROVIDERS = PROVIDERS;

/** Lightweight list for the system-selection step. */
export function listProviders() {
  return PROVIDERS.map((p) => ({ key: p.key, label: p.label }));
}

/** Full descriptor for a given key, or null. */
export function getProvider(key) {
  return PROVIDERS.find((p) => p.key === key) || null;
}
